<template>
  <div>
    <v-snackbar
      class="nx-staff-set-home-page-snackbar"
      bottom
      color="nx-accent-100 nx-primary--darken-2--text"
      :value="notificationActive"
      :timeout="0"
      auto-height
    >
      <span v-text="$t('message.homepage.revertHomepage.notification')" />
      <div>
        <v-btn
          flat
          class="ml-2"
          color="nx-primary--darken-2"
          :loading="loading"
          @click="revertHomepage"
        >
          {{ $t('message.common.undo') }}
        </v-btn>
        <v-btn
          flat
          class="ml-2"
          color="nx-primary--darken-2"
          :loading="loading"
          @click="confirmHomepage"
        >
          {{ $t('message.common.accept') }}
        </v-btn>
      </div>
    </v-snackbar>
    <v-snackbar
      class="nx-staff-set-home-page-snackbar"
      bottom
      color="nx-accent-100 nx-primary--darken-2--text"
      :value="confirmationActive"
      :timeout="0"
      auto-height
    >
      <v-progress-linear
        :value="confirmationSnackbarProgress"
        height="4"
      />
      <span v-text="$t('message.homepage.revertHomepage.reverted')" />
      <v-btn
        flat
        color="nx-primary--darken-2"
      >
        {{ $t('message.common.accept') }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import countdown from '@/utils/countdown';

export default {
  name: 'NxStaffSetHomepageSnackbar',
  data() {
    return {
      notificationActive: true,
      confirmationSnackbarProgress: 0,
      loading: false,
    };
  },
  computed: {
    confirmationActive() {
      return this.confirmationSnackbarProgress > 0;
    },
  },
  methods: {
    async revertHomepage() {
      const contentSearchRoute = this.$router.resolve({ name: 'searcher', params: { entity: 'content' } });
      const { name, params } = contentSearchRoute.route;
      await this.updateDashboardRevertHomepageShown({ name, params });

      this.initConfirmationCountdown();
    },

    async confirmHomepage() {
      const contentSearchRoute = this.$router.resolve({ name: 'dashboard' });
      const { name, params } = contentSearchRoute.route;
      await this.updateDashboardRevertHomepageShown({ name, params });
    },

    async updateDashboardRevertHomepageShown(homepage) {
      if (this.loading) return Promise.resolve();
      this.loading = true;

      return this.$store.dispatch('UPDATE_DASHBOARD_REVERT_HOMEPAGE_SHOWN', {
        dashboardRevertHomepageShown: true,
        homepage,
      })
        .finally(() => {
          this.loading = false;
          this.notificationActive = false;
        });
    },

    initConfirmationCountdown() {
      const duration = 10;
      countdown(10, ({ elapsedTime }) => {
        const percentage = elapsedTime * 100 / (duration * 1000);
        this.confirmationSnackbarProgress = Math.max(0, (100 - percentage));
      });
    },
  },
};
</script>

<style lang="stylus">
@import '../../../assets/stylus/variables.styl';

.nx-staff-set-home-page-snackbar {
  bottom: 8px;

  .v-snack {
    &__wrapper {
      max-width: 600px;
    }

    &__content {
      position: relative
    }
  }

  .v-progress-linear {
    position: absolute;
    top: -15px
    left: 0
  }
}
</style>
